<template>
<div>
  <div
      v-if="!showAddForm"
      @click="showAddForm = !showAddForm"
      class="settings-button switched-colors d-inline-block">
    {{ $t('add sensor') }} <icon type="plus-alt" />
  </div>
  <div v-if="showAddForm">
    <input type="text" class="form-text form-text-dark" v-model="name" placeholder="name" />
    <div
        @click="abort"
        class="settings-button switched-colors d-inline-block mt-1">
      {{ $t('abort') }}
    </div>
    <div
        v-if="name"
        @click="save"
        class="settings-button action-button float-none d-inline-block mt-1 ml-1">
      {{ $t('save') }}
    </div>
  </div>
  <div v-if="routerLink">
    Your sensor has been created. You can find it here:
    <router-link class="settings-button switched-colors d-inline-block ml-1" target="_blank" :to="routerLink">{{ name }}</router-link>
  </div>
</div>
</template>

<script>
import Icon from "@/components/Icon.vue";
import {SpecialUuids} from "../enum";
export default {
  name: "SensorAddForm",
  components: {Icon},
  props: {
    organizationId: {type: String, required: true},
    teams: {type: Array, required: true},
    feedId: {type: String, required: true}
  },
  data() {
    return {
      showAddForm: false,
      name: '',
      routerLink: '',
    }
  },
  methods: {
    async setUpSensor(sensorId, sensorName) {
      return this.$store.dispatch('clientSaveAssetMetaSetValues', {
            id: sensorId,
            values: [{
              metaFieldId: SpecialUuids.SENSOR_SOURCE_FEED_METAFIELD,
              value: this.feedId
            }, {
              metaFieldId: SpecialUuids.SENSOR_FILTER_METAFIELD,
              value: JSON.stringify({
                "unique_sensor_name": sensorName
              })
            }]
      });
    },
    async save() {
      let args = {
        name: this.name,
        description: this.description,
        type: 'sensor',
        organizationId: this.organizationId,
        teams: this.teams
      };
      await this.$store.dispatch('createDatasource', args)
          .then(async item => {
            await this.setUpSensor(item.id, item.name);
            return item;
          }).then(item => {
            this.routerLink = '/library/datasource/' + item.id + '/general';
            this.showAddForm = false;
            this.$emit('sensorAdded')
          })
    },
    abort() {
      this.name = '';
      this.showAddForm = false;
    }
  }
}
</script>

<style scoped lang="scss">

</style>